angular.module('FlexyBeautyApp.services')
    .factory('UboStatement_Resource', ["$resource", "$location", function ($resource, $location) {
        let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
        return $resource(baseUrl + "rest/kyc/ubo/statements", {}, {
            query: {method: 'GET', isArray: false},
            update: {method: 'PUT'}
        });
    }]);

angular.module('FlexyBeautyApp.services')
    .factory('UboStatement', ["UboStatementData", "Ubo", "UboStatement_Resource",
        function (UboStatementData, Ubo, UboStatement_Resource) {
            let UboStatement = function (resource) {
                this.id = null;
                this.details = null;
                this.status = null;
                this.timeCreated = null;
                this.ubos = [];

                if (resource) {
                    this.loadObject(resource);
                }
                UboStatementData.add(this);
            };

            UboStatement.prototype.loadObject = function (object) {
                this.id = object.id;
                this.details = object.details;
                this.status = object.status;
                this.timeCreated = object.timeCreated;

                for (let i = 0; i < object.ubos.length; i++) {
                    this.ubos.push(new Ubo(object.ubos[i]));
                }
            };

            UboStatement.prototype.getObjectResource = function() {
                let rsUboStatement = new UboStatement_Resource();
                if (this.id) {
                    rsUboStatement.id = this.id;
                }
                rsUboStatement.ubos = this.ubos;

                return rsUboStatement;
            };

        return UboStatement;
    }
]);

angular.module('FlexyBeautyApp.services')
    .factory('UboStatementSrv', ["UboStatement_Resource", "UboStatement", "UboStatementData",
        function (UboStatement_Resource, UboStatement, UboStatementData) {
            let uboStatementSrv = {};
            uboStatementSrv.query = function () {
                return UboStatement_Resource.query().$promise.then(
                    res => {
                        if (res && res.uboStatements) {
                            UboStatementData.clear();
                            for (let i = 0; i < res.uboStatements.length; i++) {
                                new UboStatement(res.uboStatements[i]);
                            }
                        }
                    }
                );
            };

            uboStatementSrv.save = function (uboStatement) {
                let uboStatementResource = uboStatement.getObjectResource();
                return uboStatementResource.$save({});
            };

            uboStatementSrv.update = function (uboStatement) {
                let uboStatementResource = uboStatement.getObjectResource();
                return uboStatementResource.$update();
            };

        return uboStatementSrv;
    }
]);

angular.module('FlexyBeautyApp.services')
    .factory('UboStatementData', function () {
    let uboStatementData = {
        uboStatements: []
    };

    uboStatementData.getById = function(id) {
        return this.uboStatements.find(item => item.id === id);
    };

    uboStatementData.getUboStatements = function() {
        return this.uboStatements;
    };

    uboStatementData.clear = function() {
        this.uboStatements = [];
    };

    uboStatementData.add = function(ubo) {
        this.uboStatements.push(ubo);
    };
    return uboStatementData;
});


// WEBPACK FOOTER //
// ./js/services/models/UboStatement.js